import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private configUrl = 'assets/config.json'; // Path to your config.json file

  constructor(private http: HttpClient) {}

  getEnvironment(): Observable<any> {
    return of(`${environment.env} : ${environment.version}`);
  }
}
